import React from 'react';
import { AcceptDeclineForm } from '../../../_lib/Form2';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import ModalDialog from '../../../components/organisms/ModalDialog/ModalDialog';
import { SharedFile } from '../SharedFiles.types';
import { useSharedFilesSelectedItemsContext } from '../context/SharedFilesSelectedItems';

type SharedFilesItemDeleteForm = {
  closeModal: () => void;
  file: SharedFile;
};

export function SharedFilesItemDeleteForm({ closeModal, file }: SharedFilesItemDeleteForm) {
  const { t } = useSonTranslation('SharedFiles');
  const { removeDeletedItemFromSelected } = useSharedFilesSelectedItemsContext();

  return (
    <ModalDialog
      closeModal={closeModal}
      headline={t('forms.delete.modalHeadline', { name: file.fileTitle || file.fileName })}
      initialFocusIndex={1}
    >
      <AcceptDeclineForm
        form={file.forms!.delete!}
        // global forms need this update as selection changed
        onSuccess={() => removeDeletedItemFromSelected(file.id)}
        headline={t('forms.delete.headline', { name: file.fileTitle || file.fileName })}
        messageSuccess={t('forms.delete.success')}
        messageSending={t('forms.delete.sending')}
        messageFail={t('forms.delete.fail')}
      />
    </ModalDialog>
  );
}
